module.exports = __webpack_public_path__ + "img/red.62148773.png";